// src/components/store/sections/testimonials/TestimonialV7PolaroidsnapsOceanCyan.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV7PolaroidsnapsOceanCyan(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={7}
      archKey="polaroid_snaps"
      archLabel="Polaroid Customer Snaps"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
